import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@material-ui/core';
import { Warning as WarningIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    titleBox: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1)
    },
    warningIcon: {
        color: theme.palette.error.main,
        fontSize: 32
    },
    content: {
        paddingTop: theme.spacing(2)
    }
}));

interface ClashWarningDialogProps {
    open: boolean;
    onClose: () => void;
    clashCount: number;
}

/**
 * Warning dialog shown after Best Practice application when clashes are detected.
 */
export const ClashWarningDialog: React.FC<ClashWarningDialogProps> = ({
    open,
    onClose,
    clashCount
}) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Box className={classes.titleBox}>
                    <WarningIcon className={classes.warningIcon} />
                    <Typography variant="h6">Clashes Detected</Typography>
                </Box>
            </DialogTitle>

            <DialogContent className={classes.content}>
                <Typography variant="body1" paragraph>
                    Clashes have been detected. A newer version of the Family may have been released
                    and added to the project. Specpoint is unable to apply some of the Best Practices.
                </Typography>

                <Typography variant="body2" color="textSecondary">
                    {clashCount} clash{clashCount !== 1 ? 'es' : ''} detected. Click the clash icon in the right sidebar to review and resolve.
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};
